"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fromEnv = void 0;
const credential_provider_env_1 = require("@aws-sdk/credential-provider-env");
const fromEnv = (init) => (0, credential_provider_env_1.fromEnv)(init);
exports.fromEnv = fromEnv;
